<template>
  <v-list-item>
    <v-list-item-content class="pa-0">
      <v-row class="d-flex">
        <v-col v-if="address && number && zip && neighborhood && state" sm="4">
          <p class="infoLabel">Local:</p>
          <p class="infoValue">{{ address }}, {{number}}</p>
          <p class="infoValue">CEP {{zip}} - {{neighborhood}} - {{state}}</p>
        </v-col>
        <v-col sm="6">
          <p class="infoLabel">E-mail:</p>
          <p class="infoValue">{{ email }}</p>
        </v-col>
      </v-row>
    </v-list-item-content>
  </v-list-item>
</template>

<script>
export default {
  props: {
    address: {
      type: String,
      required: false
    },
    number: {
      type: Number,
      required: false
    },
    zip: {
      type: [String, Number],
      required: false
    },
    neighborhood: {
      type: String,
      required: false
    },
    state: {
      type: String,
      required: false
    },
    email: {
      type: String,
      required: true
    }
  }
};
</script>

<style scoped>
.infoLabel {
  margin: 0;
  padding: 0;
  font-family: "Montserrat", sans-serif;
  font-weight: 500;
  font-size: 14px;
  line-height: 24px;
  letter-spacing: 0.16px;
  font-feature-settings: "pnum" on, "lnum" on;
  color: #9e9e9e;
}

.infoValue {
  margin: 0;
  padding: 0;
  font-family: "Montserrat", sans-serif;
  font-weight: 500;
  font-size: 14px;
  line-height: 24px;
  letter-spacing: 0.16px;
  font-feature-settings: "pnum" on, "lnum" on;
  color: #424242;
}
</style>